export default "__VITE_ASSET__C_k_mmLx__"